const ACTIONS = {
    CIVIL_CODE_DISCLAIMER_CLICKED: 'LISTING_PAGE/CIVIL_CODE_DISCLAIMER_CLICKED',
    INQUIRY_CLICKED: 'LISTING_PAGE/INQUIRY_CLICKED',
    VIEW_PRICE_DETAILS_CLICKED: 'LISTING_PAGE/VIEW_PRICE_DETAILS_CLICKED',
    PROCESS_SERVER_SIDE_EVALUATED_TESTS: 'LISTING_PAGE/PROCESS_SERVER_SIDE_EVALUATED_TESTS',
    ENTER_DATES_TIMER_COMPLETE: 'LISTING_PAGE/ENTER_DATES_TIMER_COMPLETE',
    TRIGGER_URGENCY_TOAST: 'LISTING_PAGE/TRIGGER_URGENCY_TOAST',
    LOG_PRICE_SUMMARY_EVENT: 'LISTING/LOG_PRICE_SUMMARY_EVENT'
};

const ACTION_CREATORS = {
    viewPriceDetailsClicked(actionLocation) {
        return {
            type: ACTIONS.VIEW_PRICE_DETAILS_CLICKED,
            payload: {
                actionLocation
            }
        };
    },
    inquiryClicked(actionLocation) {
        return {
            type: ACTIONS.INQUIRY_CLICKED,
            payload: {
                actionLocation
            }
        };
    },
    processServerSideEvaluatedTests() {
        return {
            type: ACTIONS.PROCESS_SERVER_SIDE_EVALUATED_TESTS,
            payload: {}
        };
    },
    enterDatesTimerComplete(enterDatesTimerComplete) {
        return {
            type: ACTIONS.ENTER_DATES_TIMER_COMPLETE,
            payload: {
                enterDatesTimerComplete
            }
        };
    },
    triggerUrgencyToast(element) {
        return {
            type: ACTIONS.TRIGGER_URGENCY_TOAST,
            payload: {
                element
            }
        };
    },
    logPriceSummaryEvent(priceSummaryEventParams) {
        return {
            type: ACTIONS.LOG_PRICE_SUMMARY_EVENT,
            payload: {
                priceSummaryEventParams
            }
        };
    },
    civilCodeDisclaimerClicked(actionLocation) {
        return {
            type: ACTIONS.CIVIL_CODE_DISCLAIMER_CLICKED,
            payload: {
                actionLocation
            }
        };
    },
};

export default {...ACTIONS, ...ACTION_CREATORS};
